import { useSelector } from 'react-redux'

const useGetCompanyInfo = () => {
  const companyInfo = useSelector( state => state.common.user.license.company)
  return companyInfo;
}

export default useGetCompanyInfo;